"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
require("./BubbleChart.scss");
const constants_1 = require("../../constants");
const Tooltip_1 = __importDefault(require("../Tooltip"));
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const chart_helpers_1 = require("../../util/chart.helpers");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const error_1 = require("../error");
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const BIGGEST_BUBBLE_PERCENT = 0.1;
const DEFAULT_HEIGHT = 200;
const AXIS_LABEL_SPACING = 20;
const DEFAULT_TICK_SIZE = 6;
const back1Grey = 'rgb(234,234,234)';
const back2Grey = 'rgb(247,247,247)';
const unselectedGrey = 'rgb(234,234,234)';
const back1Selected = 'rgb(164,164,164)';
const back2Selected = 'rgb(173,173,173)';
function createScales(_ref) {
  let {
    data,
    params: {
      startDate,
      endDate,
      xDomain,
      yDomain,
      margins,
      maxRadiusPercent
    }
  } = _ref;
  const {
    height,
    width
  } = this.chartArea(margins);
  const dataPoints = (0, chart_helpers_1.allDataPoints)(data, startDate, endDate, data[0] ? data[0].metric.xType : 'years');
  const dataXDomain = [Math.min(0, d3.min(dataPoints, d => d.x)), Math.max(0, d3.max(dataPoints, d => d.x))];
  const dataYDomain = [Math.min(0, d3.min(dataPoints, d => d.y)), Math.max(0, d3.max(dataPoints, d => d.y))];
  const bubbleDomain = [0, d3.max(dataPoints, d => d.value)];
  const biggestRadius = width * maxRadiusPercent;
  return {
    xScale: d3.scaleLinear().domain(xDomain || dataXDomain).range([0, width]).nice(),
    yScale: d3.scaleLinear().domain(yDomain || dataYDomain).range([height, 0]).nice(),
    bubbleScale: d3.scalePow().exponent(0.5).domain(bubbleDomain).range([0, biggestRadius])
  };
}
class BubbleChart {
  constructor(container, width, height) {
    this.chartType = constants_1.CHART_TYPES.BubbleChart;
    this.cssPrefix = 'bubble-chart';
    this.margins = {
      top: 0,
      bottom: 20,
      left: 50,
      right: 0
    };
    this.yTicks = 6;
    this.xTicks = 8;
    this.width = width || 1000;
    this.height = height || DEFAULT_HEIGHT;
    this.title = container.append('div').classed('chart-title', true);
    this.subtitle = container.append('div').classed('chart-subtitle', true);
    this.controls = container.append('div').classed('bubble-chart-controls', true);
    this.container = container.classed('bubble-chart', true).classed('dh-chart-wrapper', true);
    this.svg = container.append('svg').classed('bubble-chart', true);
    this.sourceContainer = container.append('div').classed('footer', true);
    this.tooltip = new Tooltip_1.default(container);
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.dropdownSelected = null;
    this.playingID = null;
    this.selected = null;
    this.firstDraw = true;
    this.initGroups();
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        if (this.width === containerWidth || containerWidth === 0) {
          return;
        }
        requestAnimationFrame(() => {
          this.width = containerWidth;
          this.redrawContent();
        });
      });
    });
    this.ro.observe(container.node());
  }
  initGroups() {
    this.svgAll = this.svg.append('g').classed('bubble-chart-all', true);
    this.svgAll.append('g').classed('axis', true).classed('x', true);
    this.svgAll.append('g').classed('axis', true).classed('axis-back', true).classed('y', true);
    this.svgAll.append('g').classed('axis', true).classed('x-label', true);
    this.svgAll.append('g').classed('axis', true).classed('y-label', true);
    this.svgAll.append('line').classed('vertical-line', true);
    this.svgAll.append('text').classed('vertical-label', true);
    this.svgAll.append('line').classed('horizontal-line', true);
    this.svgAll.append('text').classed('horizontal-label', true);
    this.svgAll.append('rect').classed('bubble-chart-clickout', true);
    this.svgAll.append('g').classed('bubble-chart-chart', true);
    this.svgAll.append('g').classed('axis', true).classed('axis-front', true).classed('y', true);
    error_1.initError.call(this);
  }
  async data(promises) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      parent
    } = fetched;
    const bubbleData = data.map(_ref2 => {
      let [bubbleMetric, xMetric, yMetric] = _ref2;
      return {
        ...bubbleMetric,
        metric: {
          ...bubbleMetric.metric,
          data: bubbleMetric.metric.data.map(d => ({
            ...d,
            x: xMetric.metric.data.find(xm => BubbleChart.keyMatches(xm.key, d.key, xMetric.metric.xType)).value,
            y: yMetric.metric.data.find(ym => BubbleChart.keyMatches(ym.key, d.key, yMetric.metric.xType)).value
          }))
        },
        xMetric,
        yMetric,
        bubbleMetric
      };
    });
    let keysAreDates = true;
    const keys = (0, lodash_1.default)(bubbleData).flatMap(d => d.metric.data.map(_ref3 => {
      let {
        key
      } = _ref3;
      if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') {
        keysAreDates = false;
        return key;
      }
      return (0, chart_helpers_1.dateFormat)(key, d.metric.xType);
    })).uniq().value();
    if (this.dropdownSelected === null || !keys.includes(this.dropdownSelected)) {
      if (!keysAreDates) {
        this.dropdownSelected = lodash_1.default.first(keys);
      } else {
        this.dropdownSelected = lodash_1.default.last(keys);
      }
    }
    return {
      data: bubbleData,
      parent,
      keys
    };
  }
  chartArea(margins) {
    return {
      width: this.width - margins.left - margins.right,
      height: this.height - margins.top - margins.bottom
    };
  }
  getAdjustedMargins(_ref4) {
    let {
      safeMargins,
      maxRadiusPercent,
      margins,
      xLabel,
      yLabel
    } = _ref4;
    const {
      top,
      right,
      bottom,
      left
    } = margins;
    if (safeMargins) {
      return {
        top: Math.max(top, maxRadiusPercent * this.width),
        right: Math.max(right, maxRadiusPercent * this.width),
        bottom: Math.max(bottom, maxRadiusPercent * this.width),
        left: Math.max(left, maxRadiusPercent * this.width)
      };
    }
    return {
      top: this.margins.top + (top || 0) + (yLabel ? AXIS_LABEL_SPACING + 10 : 0),
      right: this.margins.right + (right || 0) + AXIS_LABEL_SPACING,
      bottom: this.margins.bottom + (bottom || 0) + (xLabel ? AXIS_LABEL_SPACING : 0),
      left: this.margins.left + (left || 0)
    };
  }
  getDrawParams(_ref5) {
    let {
      data,
      parent,
      options: {
        metricLabels = ['', '', ''],
        hideGridlines = true,
        hideAxisLabels = false,
        primaryColor = null,
        axisTextColor = common_module_scss_1.default.chartAxisFontColor,
        gridColor = null,
        xLabel = '',
        yLabel = '',
        heightToWidthRatio = null,
        maxRadiusPercent = BIGGEST_BUBBLE_PERCENT,
        safeMargins = true,
        hideYear = false,
        startDate = null,
        verticalLine = {},
        horizontalLine = {},
        showSourcesAndFootnotes = true,
        ...otherOptions
      }
    } = _ref5;
    const params = {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        parent,
        options: otherOptions
      }, this.margins),
      metricLabels,
      hideGridlines,
      hideAxisLabels,
      primaryColor,
      axisTextColor,
      gridColor,
      xLabel,
      yLabel,
      heightToWidthRatio,
      maxRadiusPercent,
      safeMargins,
      hideYear,
      startDate,
      verticalLine,
      horizontalLine,
      showSourcesAndFootnotes
    };
    // BubbleChart overrides the default margins behaviour to fit labels and stuff
    params.margins = this.getAdjustedMargins(params);
    return params;
  }
  setDropdownSelected(key) {
    this.dropdownSelected = key;
  }
  redrawContent() {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams);
    }
  }
  static getTooltipFormats(d, parent) {
    return {
      bubbleFormat: (0, chart_helpers_1.tooltipFormat)({
        data: [d.bubbleMetric],
        parent,
        params: {}
      }),
      xFormat: (0, chart_helpers_1.tooltipFormat)({
        data: [d.xMetric],
        parent,
        params: {}
      }),
      yFormat: (0, chart_helpers_1.tooltipFormat)({
        data: [d.yMetric],
        parent,
        params: {}
      })
    };
  }
  showTooltip(_ref6, d, key, leftPad, colour) {
    let {
      parent,
      params
    } = _ref6;
    const containerDim = this.container.node().getBoundingClientRect();
    const svgDim = this.svg.node().getBoundingClientRect();
    const {
      width
    } = containerDim;
    const bubbleX = this.xScale(this.xAccessor(d));
    const bubbleY = this.yScale(this.yAccessor(d));
    const bubbleValue = this.valueAccessor(d);
    const x = (leftPad + bubbleX) * width / this.width;
    const y = svgDim.top - containerDim.top + bubbleY + params.margins.top;
    const {
      bubbleFormat,
      xFormat,
      yFormat
    } = BubbleChart.getTooltipFormats(d, parent);
    const rows = [{
      type: 'keyValues',
      key: 'bubble',
      values: [{
        key: params.metricLabels[0],
        value: bubbleFormat(bubbleValue, {
          truncate: true
        })
      }, {
        key: params.metricLabels[1],
        value: xFormat(this.xAccessor(d), {
          truncate: true
        }),
        styles: {
          'font-size': '0.6em'
        }
      }, {
        key: params.metricLabels[2],
        value: yFormat(this.yAccessor(d), {
          truncate: true
        }),
        styles: {
          'font-size': '0.6em'
        }
      }]
    }];
    const topContent = {
      title: {
        value: d.tooltipTitle ?? d.metric.name
      },
      subtitle: {
        value: key
      }
    };
    this.tooltip.draw(x, y, topContent, rows, {
      primaryColour: colour
    }, this.bubbleScale(bubbleValue));
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const drawParams = {
      ...allData,
      options
    };
    this.drawContent(drawParams);
    return true;
  }
  drawContent(_ref7) {
    let {
      data,
      parent,
      keys,
      options
    } = _ref7;
    this.cachedParams = {
      data,
      parent,
      keys,
      options
    };
    const params = this.getDrawParams({
      data,
      parent,
      options
    });
    if (keys.includes(params.startDate) && this.firstDraw) this.dropdownSelected = params.startDate;
    if (params.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node());
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node());
      this.container.node().insertBefore(this.controls.node(), this.svg.node());
    } else if (params.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.controls.node());
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
    }
    this.drawTitleContent({
      params,
      keys
    });
    if (params.showSourcesAndFootnotes) {
      this.sources.draw(data, params);
    }
    if (params.heightToWidthRatio) {
      this.height = params.heightToWidthRatio * this.width;
    } else {
      const {
        height: titleHeight
      } = this.title.node().getBoundingClientRect();
      const {
        height: subtitleHeight
      } = this.subtitle.node().getBoundingClientRect();
      const {
        height: controlsHeight
      } = this.controls.node().getBoundingClientRect();
      const {
        height: wrapperHeight
      } = this.container.node().getBoundingClientRect();
      const {
        height: footerHeight
      } = this.sourceContainer.node().getBoundingClientRect();
      this.height = Math.max(DEFAULT_HEIGHT, wrapperHeight - titleHeight - subtitleHeight - controlsHeight - footerHeight);
    }
    d3.select(this.svg.node()).attr('viewBox', `0 0 ${this.width} ${this.height}`);
    const scales = createScales.call(this, {
      data,
      params
    });
    this.xScale = scales.xScale;
    this.yScale = scales.yScale;
    this.bubbleScale = scales.bubbleScale;
    this.svg.select('rect.bubble-chart-clickout').attr('x', -params.margins.left).attr('y', -params.margins.top).attr('width', this.width).attr('height', this.height).on('click', () => {
      if (this.selected) {
        this.selected = null;
        this.redrawContent();
      }
    }, {
      passive: true
    });
    this.drawAllBubbles({
      data,
      parent,
      params
    });
    this.drawAxes({
      data,
      parent,
      params
    }, scales);
    if (params.info && params.info.position === 'chart') {
      InfoTooltip_1.default.inChart(this.container, params);
    }
    this.firstDraw = false;
    this.svg.select('g.bubble-chart-all').attr('transform', `translate(${params.margins.left}, ${params.margins.top})`);
  }
  static keyMatches(d, selected, xType) {
    if (xType && xType.toLowerCase() === 'items') {
      return d === selected;
    }
    if (!selected.getTime) {
      return d.getTime() === (0, chart_helpers_1.dateParser)(selected, xType).getTime();
    }
    return d.getTime() === selected.getTime();
  }
  xAccessor(d, key) {
    const set = d.metric.data.find(v => BubbleChart.keyMatches(v.key, key || this.dropdownSelected, d.metric.xType));
    return set ? set.x : null;
  }
  yAccessor(d, key) {
    const set = d.metric.data.find(v => BubbleChart.keyMatches(v.key, key || this.dropdownSelected, d.metric.xType));
    return set ? set.y : null;
  }
  valueAccessor(d, key) {
    const set = d.metric.data.find(v => BubbleChart.keyMatches(v.key, key || this.dropdownSelected, d.metric.xType));
    return set ? set.value : null;
  }
  drawTitleContent(_ref8) {
    let {
      params,
      keys
    } = _ref8;
    chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, {
      params
    });
    const controlParams = {
      ...params,
      title: '',
      info: {}
    };
    chart_helpers_1.drawTitle.call(this, this.controls, this.subtitle, {
      params: controlParams,
      keys
    }, this.dropdownSelected);
    if (params.hideYear) {
      this.controls.style('display', 'none');
    } else {
      if (params.titleHorizontalAlignment === 'center') {
        this.title.style('margin-left', 0);
        this.subtitle.style('margin-left', 0);
      }
      let backButton = this.controls.select('div.bubble-back');
      if (backButton.empty()) {
        backButton = this.controls.insert('div', '.drop-down-wrapper').classed('bubble-back', true).text('ᐸ');
      }
      let forwardButton = this.controls.select('div.bubble-forward');
      if (forwardButton.empty()) {
        forwardButton = this.controls.append('div').classed('bubble-forward', true).text('ᐳ');
      }
      let playButton = this.controls.select('div.bubble-play');
      if (playButton.empty()) {
        playButton = this.controls.append('div').classed('bubble-play', true).text(this.playingID ? '◼' : '▶');
      }
      playButton.on('click', () => {
        if (this.playingID) {
          clearInterval(this.playingID);
          playButton.text('▶');
          this.playingID = null;
          this.playingstartDate = null;
          this.redrawContent();
        } else {
          this.playingstartDate = this.dropdownSelected;
          this.playingID = setInterval(() => {
            const currentIndex = keys.findIndex(key => key === this.dropdownSelected);
            this.dropdownSelected = keys[(currentIndex + 1) % keys.length];
            this.redrawContent();
          }, 1000);
          playButton.text('◼');
        }
      }, {
        passive: true
      });
      backButton.on('click', () => {
        const currentIndex = keys.findIndex(key => key === this.dropdownSelected);
        this.dropdownSelected = keys[(currentIndex + keys.length - 1) % keys.length];
        if (this.playingID) {
          clearInterval(this.playingID);
          playButton.text('▶');
          this.playingID = null;
          this.playingstartDate = null;
        }
        this.redrawContent();
      }, {
        passive: true
      });
      forwardButton.on('click', () => {
        const currentIndex = keys.findIndex(key => key === this.dropdownSelected);
        this.dropdownSelected = keys[(currentIndex + 1) % keys.length];
        if (this.playingID) {
          clearInterval(this.playingID);
          playButton.text('▶');
          this.playingID = null;
          this.playingstartDate = null;
        }
        this.redrawContent();
      }, {
        passive: true
      });
    }
  }
  getBubbleColour(d, i, params, nonSelectedColour, selectedColour, fadeWhenNotSelected) {
    let colour = nonSelectedColour;
    if (d.id === this.selected) {
      colour = selectedColour;
    } else if (this.selected && fadeWhenNotSelected) {
      return 'rgba(0,0,0,0)';
    }
    if (colour) {
      return colour;
    }
    if (this.selected) {
      if (d.id === this.selected) {
        return (0, chart_helpers_1.getColour)(d, i, params);
      }
      return unselectedGrey;
    }
    return (0, chart_helpers_1.getColour)(d, i, params);
  }
  drawAllBubbles(_ref9) {
    let {
      data,
      parent,
      params
    } = _ref9;
    this.drawBubbles({
      data,
      parent,
      params
    }, this.dropdownSelected - 2, 'back2', back2Grey, back2Selected, false, this.firstDraw);
    this.drawBubbles({
      data,
      parent,
      params
    }, this.dropdownSelected - 1, 'back1', back1Grey, back1Selected, false, this.firstDraw);
    this.drawBubbles({
      data,
      parent,
      params
    }, this.dropdownSelected, 'now', null, null, true, this.firstDraw, true);
  }
  drawBubbles(_ref10, key, name, colour, selectedColour, isHoverable, firstDraw, drawLabels) {
    let {
      data,
      parent,
      params
    } = _ref10;
    const chart = this;
    const chartAreaGroup = this.svg.select('g.bubble-chart-chart');
    const groups = chartAreaGroup.selectAll(`g.bubble-chart-entry-${name}`).data(data, d => `${d.id}|${name}`).join(enter => {
      const group = enter.append('g').classed(`bubble-chart-entry-${name}`, true);
      group.append('circle').classed(`bubble-chart-circle-${name}`, true);
      group.append('text').classed('bubble-chart-label', true);
      return group;
    }, update => update);
    const sortKey = this.playingstartKey || key;
    groups.sort((a, b) => this.bubbleScale(this.valueAccessor(b, sortKey)) - this.bubbleScale(this.valueAccessor(a, sortKey))).selectAll('circle').style('cursor', isHoverable ? 'pointer' : null).each(function (d) {
      const wasFaded = d3.select(this.parentNode).style('opacity') === '0';
      if (firstDraw || wasFaded) {
        // fade in circles in place that had no data before
        d3.select(this).style('fill', chart.getBubbleColour(d, data.findIndex(dd => dd.id === d.id), params, colour, selectedColour, !isHoverable)).attr('cx', chart.xScale(chart.xAccessor(d, key))).attr('cy', chart.yScale(chart.yAccessor(d, key)));
      }
      if (wasFaded) {
        d3.select(this).attr('r', chart.bubbleScale(chart.valueAccessor(d, key)));
      }
    });
    groups.transition().duration(750).style('opacity', d => this.valueAccessor(d, key) === null ? 0 : 1);
    groups.filter(d => this.valueAccessor(d, key) !== null).selectAll('circle').transition().duration(750).style('fill', d => this.getBubbleColour(d, data.findIndex(dd => dd.id === d.id), params, colour, selectedColour, !isHoverable)).attr('cx', d => this.xScale(this.xAccessor(d, key))).attr('cy', d => this.yScale(this.yAccessor(d, key))).attr('r', d => this.bubbleScale(this.valueAccessor(d, key)));
    if (drawLabels) {
      groups.selectAll('text').text(d => d.labelText !== undefined ? d.labelText : d.metric.name).each(function (d) {
        if (chart.firstDraw) {
          d3.select(this).attr('x', chart.xScale(chart.xAccessor(d, chart.key))).attr('y', chart.yScale(chart.yAccessor(d, chart.key)));
        }
      });
      groups.filter(d => this.valueAccessor(d, key) !== null).selectAll('text').transition().duration(750).style('font-size', d => d.labelSize ? `${d.labelSize}px` : null).attr('x', d => this.xScale(this.xAccessor(d, this.dropdownSelected))).attr('y', d => this.yScale(this.yAccessor(d, this.dropdownSelected))).style('opacity', d => this.selected && d.id !== this.selected ? 0 : 1);
    }
    groups.filter(d => this.selected === d.id).raise();
    groups.selectAll('circle').on('mousemove', lodash_1.default.throttle((event, d) => {
      if (isHoverable) {
        const tooltipColour = colour || (0, chart_helpers_1.getColour)(d, data.findIndex(dd => dd.id === d.id), params);
        this.showTooltip({
          parent,
          params
        }, d, this.dropdownSelected, params.margins.left, tooltipColour);
      }
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    }).on('click', (event, d) => {
      if (isHoverable && this.selected !== d.id) {
        this.selected = d.id;
      } else {
        this.selected = null;
      }
      this.redrawContent();
    }, {
      passive: true
    });
  }
  drawAxes(_ref11, scales) {
    let {
      data,
      parent,
      params
    } = _ref11;
    const {
      xScale,
      yScale
    } = scales;
    const containerG = this.svg.select('g.bubble-chart-all');
    const [xStart, xEnd] = xScale.range();
    const [yStart, yEnd] = yScale.range();
    const yAxisPadding = -15;
    const axisWidth = xEnd - xStart;
    let {
      xTicks
    } = this;
    if (axisWidth < 150) {
      xTicks = 3;
    } else if (axisWidth < 300) {
      xTicks = 4;
    }
    const axisHeight = yStart - yEnd;
    let {
      yTicks
    } = this;
    if (axisHeight < 150) {
      yTicks = 3;
    } else if (axisHeight < 300) {
      yTicks = 4;
    }
    const labelPadding = 2;
    if (params.verticalLine) {
      const xRange = xScale.domain();
      const {
        xValue,
        lineColor,
        lineSize,
        labelVerticalPos,
        labelHorizontalPos,
        labelText,
        labelColor,
        fontSize
      } = {
        lineColor: '#000000',
        lineSize: 1,
        labelVerticalPos: 'top',
        labelHorizontalPos: 'right',
        labelText: '',
        labelColor: params.axisTextColor,
        fontSize: params.fontSize,
        ...params.verticalLine
      };
      if (xValue >= xRange[0] && xValue <= xRange[1]) {
        const verticalLinePos = axisWidth * (xValue - xRange[0]) / (xRange[1] - xRange[0]);
        containerG.select('.vertical-line').attr('stroke', lineColor).attr('y2', axisHeight).attr('transform', `translate(${verticalLinePos}, 0)`).attr('stroke-width', lineSize);
        const verticalLineLabelPos = [verticalLinePos + (labelHorizontalPos === 'left' ? -(labelPadding + lineSize / 2) : labelPadding + lineSize / 2), labelVerticalPos === 'top' ? fontSize : axisHeight];
        containerG.select('.vertical-label').attr('transform', `translate(${verticalLineLabelPos[0]}, ${verticalLineLabelPos[1]})`).attr('text-anchor', labelHorizontalPos === 'left' ? 'end' : 'start').attr('font-size', fontSize).attr('fill', labelColor);
        let lines = labelText.split('\n');
        if (labelVerticalPos !== 'top') lines = lines.reverse();
        containerG.select('.vertical-label').selectAll('tspan').data(lines).join('tspan').text(line => line).attr('x', 0)
        // using y instead of dy for empty lines
        .attr('y', (line, i) => fontSize * (labelVerticalPos === 'top' ? 1 : -1) * i);
      }
    }
    if (params.horizontalLine) {
      const yRange = yScale.domain();
      const {
        yValue,
        lineColor,
        lineSize,
        labelVerticalPos,
        labelHorizontalPos,
        labelText,
        labelColor,
        fontSize
      } = {
        lineColor: '#000000',
        lineSize: 1,
        labelVerticalPos: 'top',
        labelHorizontalPos: 'right',
        labelText: '',
        labelColor: params.axisTextColor,
        fontSize: params.fontSize,
        ...params.horizontalLine
      };
      if (yValue >= yRange[0] && yValue <= yRange[1]) {
        const horizontalLinePos = axisHeight * (yValue - yRange[0]) / (yRange[1] - yRange[0]);
        containerG.select('.horizontal-line').attr('stroke', lineColor).attr('x2', axisWidth).attr('transform', `translate(0, ${axisHeight - horizontalLinePos})`).attr('stroke-width', lineSize);
        const horizontalLineLabelPos = [labelHorizontalPos === 'left' ? labelPadding : axisWidth - labelPadding, axisHeight - horizontalLinePos - (labelVerticalPos === 'top' ? labelPadding + lineSize / 2 : -(fontSize + labelPadding + lineSize / 2))];
        containerG.select('.horizontal-label').attr('transform', `translate(${horizontalLineLabelPos[0]}, ${horizontalLineLabelPos[1]})`).attr('text-anchor', labelHorizontalPos === 'left' ? 'start' : 'end').attr('font-size', fontSize).attr('fill', labelColor);
        let lines = labelText.split('\n');
        if (labelVerticalPos === 'top') lines = lines.reverse();
        containerG.select('.horizontal-label').selectAll('tspan').data(lines).join('tspan').text(line => line).attr('x', 0).attr('y', (line, i) => fontSize * (labelVerticalPos === 'top' ? -1 : 1) * i);
      }
    }
    const xAxisSpec = d3.axisBottom(xScale).ticks(xTicks).tickFormat((0, chart_helpers_1.valueFormat)({
      parent,
      params,
      data: data.map(d => d.xMetric)
    })).tickSize(params.hideGridlines ? DEFAULT_TICK_SIZE : yEnd - yStart);
    const xAxis = containerG.select('.axis.x').attr('transform', `translate(0, ${yStart})`).call(xAxisSpec);
    const xAxisText = xAxis.selectAll('.tick text').attr('transform', `translate(0, ${DEFAULT_TICK_SIZE / 2})`).style('font-size', `${params.fontSize}px`).style('display', params.hideAxisLabels ? 'none' : null).style('fill', params.axisTextColor);
    xAxis.selectAll('.tick line').classed('bold', d => !xScale.domain().includes(0) && d === 0).style('stroke', params.gridColor);
    const yAxisFrontSpec = d3.axisLeft(yScale).ticks(yTicks).tickSize(0).tickFormat((0, chart_helpers_1.valueFormat)({
      parent,
      params,
      data: data.map(d => d.yMetric)
    }));
    const yAxisFront = containerG.select('.axis-front.y').call(yAxisFrontSpec);
    yAxisFront.selectAll('.tick text').style('fill', params.axisTextColor).style('display', params.hideAxisLabels ? 'none' : null);
    yAxisFront.selectAll('text').style('font-size', `${params.fontSize}px`).attr('x', yAxisPadding);
    const yAxisBack = containerG.select('.axis-back.y').call(d3.axisLeft(yScale).ticks(yTicks).tickFormat((0, chart_helpers_1.valueFormat)({
      data,
      parent,
      params
    })).tickSize(params.hideGridlines ? DEFAULT_TICK_SIZE : xStart - xEnd));
    yAxisBack.selectAll('.tick line').classed('bold', d => !yScale.domain().includes(0) && d === 0).style('stroke', params.gridColor);
    yAxisBack.selectAll('text').style('font-size', `${params.fontSize}px`).attr('x', yAxisPadding);
    this.svg.select('.x-label').selectAll('text').data([params.xLabel]).enter().append('text');
    // line up x label with rightmost x axis tick label
    const xLabelOffset = lodash_1.default.maxBy(xAxisText.nodes(), t => t.getBoundingClientRect().x).getBoundingClientRect().width / 2;
    this.svg.selectAll('.x-label text').attr('transform', `translate(0, ${yStart})`).attr('x', xEnd + xLabelOffset)
    // translate + tickPadding()
    .attr('y', DEFAULT_TICK_SIZE + 23)
    // default dy for left axis
    .attr('dy', '0.32em').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor).text(d => d);
    this.svg.select('.y-label').selectAll('text').data([params.yLabel]).enter().append('text');
    this.svg.selectAll('.y-label text')
    // default x
    .attr('x', yAxisPadding).attr('y', -20)
    // default dy for left axis
    .attr('dy', '0.32em').style('font-size', `${params.fontSize}px`).style('fill', params.axisTextColor).text(d => d);
  }
}
exports.default = BubbleChart;